import { AXIS, DIRECTION } from "@/libs/ui/CircleScanFrame"

export const getGuideDirection = ({
  axis,
  rotations: { yaw, pitch },
  targetBounds: [lower, upper] = [0, 0],
}: {
  axis: AXIS
  rotations: { yaw: number; pitch: number }
  targetBounds?: [lower: number, upper: number]
}) => {
  if (axis === AXIS.PITCH) {
    if (pitch > upper) return DIRECTION.UP
    if (pitch < lower) return DIRECTION.DOWN
  }

  if (yaw > upper) return DIRECTION.RIGHT
  if (yaw < lower) return DIRECTION.LEFT

  return null
}

export const getGuideRotation = ({
  axis,
  rotations,
}: {
  axis?: AXIS | null
  rotations?: { yaw: number; pitch: number }
}) => {
  if (!axis) return 0

  return (axis === AXIS.PITCH ? rotations?.pitch : rotations?.yaw) ?? 0
}
